import { QuestionIds } from "./QuestionPresentation";

export enum titleIds {
  TyreConditionId = 15,
  InteriorGlassConditonId = 16,
  MechanicalElectConditionId = 17,
  WheelCondition = 18
}

export enum questionCategories {
  ASSUMPTION = "Assumption",
  CONDITION = "Condition",
  FACTUAL = "Factual"
}

export const ConditionalQuestionsFromAssumptionsIds = [
  QuestionIds.GLASS,
  QuestionIds.MISSINGITEMS,
  QuestionIds.MODIFICATIONS
];

export const MultipleChoiceQuestionIds = [
  QuestionIds.GLASS,
  QuestionIds.MISSINGITEMS,
]

export const QuestionData = {
  ConditionQuestionSubtitles: {
    [titleIds.TyreConditionId]: "Tyres condition",
    [titleIds.InteriorGlassConditonId]: "Interior and glass condition",
    [titleIds.MechanicalElectConditionId]:
      "Mechanical and electrical condition",
    [titleIds.WheelCondition]: "Wheel condition"
  },
  defaultBodyWorkAnswer: 34,
  privateHireQuestionId: 11
};

export const TooltipReplaceableValues = {
  MANUFACTURER: "{manufacturer}"
};

export const INSURANCELOSS_DEFAULT_ANSWER_ID = 17;